import { Button, Modal } from "antd";

export interface ConfirmDeleteLogoModalProps {
  isVisible: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmDeleteLogoModal({
  isVisible,
  isLoading,
  onCancel,
  onConfirm,
}: ConfirmDeleteLogoModalProps) {
  return (
    <Modal
      className={"clean one"}
      onCancel={() => onCancel()}
      visible={isVisible}
    >
      <header>
        <h2>Are you sure?</h2>
      </header>

      <p>This logo will be removed from your library.</p>

      <footer>
        <Button size={"large"} onClick={() => onCancel()}>
          Cancel
        </Button>
        <Button size={"large"} className={"primary"} onClick={onConfirm} loading={isLoading}>
          Ok
        </Button>
      </footer>
    </Modal>
  );
}
